import { bootstrapPortal } from '@/shared/app/bootstrapPortal';
import SiteComplianceApp from './SiteComplianceApp';

import '@wk/components-react16/dist/all.min.css';
import '@/index.css';

bootstrapPortal(<SiteComplianceApp />);
